import OperationsSection from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/OperationsSection';

export default OperationsSection;
